import * as React from 'react';
import { createElement, useState } from 'react';
import { Table } from 'antd';
import { ArrayBase } from '@formily/antd';
import { observer, VoidField } from '@formily/react';
import { useCurrentDocument, useCurrentNode, queryNodesByComponentPath, hasNodeByComponentPath, } from './hooks';
import { uuid } from '../../shared';
const HeaderCell = (props) => {
    return (createElement("th", Object.assign({}, props, { "data-designer-node-id": props.className.match(/data-id\:([^\s]+)/)?.[1] }), props.children));
};
const BodyCell = (props) => {
    return (createElement("td", Object.assign({}, props, { "data-designer-node-id": props.className.match(/data-id\:([^\s]+)/)?.[1] }), props.children));
};
export const ArrayTablePreview = observer((props) => {
    const { columns, children, ...extra } = props;
    const [defaultName] = useState(uuid());
    const { componentId } = extra;
    const currentNode = useCurrentNode(componentId);
    const currentDocument = useCurrentDocument();
    const columnsNodes = queryNodesByComponentPath(currentNode, [
        'FormilyArrayTable',
        'FormilyArrayTable.Column',
    ]);
    const indexNodes = queryNodesByComponentPath(currentNode, [
        'FormilyArrayTable',
        'FormilyArrayTable.Index',
    ]);
    const sortNodes = queryNodesByComponentPath(currentNode, [
        'FormilyArrayTable',
        'FormilyArrayTable.SortHandle',
    ]);
    const operationNodes = queryNodesByComponentPath(currentNode, [
        'FormilyArrayTable',
        'FormilyArrayTable.Operation',
    ]);
    const additionNodes = queryNodesByComponentPath(currentNode, [
        'FormilyArrayTable',
        'FormilyArrayTable.Addition',
    ]);
    const renderTable = () => {
        if (currentNode.children.size === 0) {
            return createElement("div", null, "Empty");
        }
        return (createElement(VoidField, { name: props.fieldProps.name || defaultName },
            createElement(ArrayBase, { disabled: true },
                createElement(Table, Object.assign({ size: "small", bordered: true }, extra, { scroll: { x: '100%' }, style: { marginBottom: 10, ...props.style }, rowKey: 'id', dataSource: [{ id: '1' }], pagination: false, components: {
                        header: {
                            cell: HeaderCell,
                        },
                        body: {
                            cell: BodyCell,
                        },
                    } }),
                    sortNodes.length > 0 &&
                        sortNodes.map((_, index) => {
                            return (createElement(React.Fragment, { key: index }, React.createElement(Table.Column, {
                                title: 'Sort',
                                render: () => {
                                    return createElement(ArrayBase.SortHandle, null);
                                },
                            })));
                        }),
                    indexNodes.length > 0 &&
                        indexNodes.map((_, index) => {
                            return (createElement(React.Fragment, { key: index }, React.createElement(Table.Column, {
                                title: 'Index',
                                render: () => {
                                    return createElement(ArrayBase.Index, null);
                                },
                            })));
                        }),
                    columnsNodes.length > 0 &&
                        React.Children.map(children, (child) => {
                            if (child.props._componentName !== 'FormilyArrayTable.Column') {
                                return null;
                            }
                            return (createElement(React.Fragment, null, React.createElement(Table.Column, {
                                title: child?.props?.title || 'title',
                                render: () => {
                                    return createElement("div", null, child);
                                },
                            })));
                        }),
                    operationNodes.length > 0 &&
                        operationNodes.map((_, index) => {
                            return (createElement(React.Fragment, { key: index }, React.createElement(Table.Column, {
                                title: 'Operation',
                                render: () => {
                                    return (createElement(React.Fragment, null,
                                        createElement(ArrayBase.Remove, null),
                                        createElement(ArrayBase.MoveDown, null),
                                        createElement(ArrayBase.MoveUp, null)));
                                },
                            })));
                        })),
                additionNodes.length > 0 &&
                    additionNodes.map((_, index) => {
                        return createElement(React.Fragment, { key: index }, createElement(ArrayBase.Addition, null));
                    }))));
    };
    return (createElement(React.Fragment, null,
        renderTable(),
        createElement("div", { style: { textAlign: 'center' } },
            createElement("button", { onClick: () => {
                    if (hasNodeByComponentPath(currentNode, [
                        'FormilyArrayTable',
                        'FormilyArrayTable.SortHandle',
                    ])) {
                        return;
                    }
                    const newNode = currentDocument.createNode({
                        componentName: 'FormilyArrayTable.SortHandle',
                    });
                    currentNode.insertAfter(newNode);
                    newNode.select();
                } }, "\u6DFB\u52A0\u6392\u5E8F"),
            createElement("button", { onClick: () => {
                    if (hasNodeByComponentPath(currentNode, ['FormilyArrayTable', 'FormilyArrayTable.Index'])) {
                        return;
                    }
                    const newNode = currentDocument.createNode({
                        componentName: 'FormilyArrayTable.Index',
                    });
                    currentNode.insertAfter(newNode);
                    newNode.select();
                } }, "\u6DFB\u52A0\u7D22\u5F15"),
            createElement("button", { onClick: () => {
                    const newNode = currentDocument.createNode({
                        componentName: 'FormilyArrayTable.Column',
                    });
                    currentNode.insertAfter(newNode);
                    newNode.select();
                } }, "\u6DFB\u52A0\u5217"),
            createElement("button", { onClick: () => {
                    if (hasNodeByComponentPath(currentNode, [
                        'FormilyArrayTable',
                        'FormilyArrayTable.Operation',
                    ])) {
                        return;
                    }
                    const newNode = currentDocument.createNode({
                        componentName: 'FormilyArrayTable.Operation',
                    });
                    currentNode.insertAfter(newNode);
                    newNode.select();
                } }, "\u6DFB\u52A0\u64CD\u4F5C"),
            createElement("button", { onClick: () => {
                    if (hasNodeByComponentPath(currentNode, [
                        'FormilyArrayTable',
                        'FormilyArrayTable.Addition',
                    ])) {
                        return;
                    }
                    const newNode = currentDocument.createNode({
                        componentName: 'FormilyArrayTable.Addition',
                    });
                    currentNode.insertAfter(newNode);
                    newNode.select();
                } }, "\u65B0\u589E\u64CD\u4F5C"))));
});
ArrayBase.mixin(ArrayTablePreview);
